import axios from "axios";
import { END_POINT } from "../../Redux/AdminReducer/action";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CameraCapture from "../../Components/CommonComponents/CameraCapture";

// Public pages have no login token, so the backend picks the clinic database
// from the frontend host.
const tenantHeaders = () => ({ 'X-Frontend-Host': window.location.host });

const verifyphone = async (phone, patientId) => {
  try {
    const result = await axios.post(
      `${END_POINT}/customer/public/verifyPhone`,
      { phone, patientId },
      { headers: tenantHeaders() }
    );
    return result?.data;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.error || "Something went wrong while verifying the number");
  }
};

const UploadFiles = async (files, customerId, phone, prescriptionId) => {
  const formData = new FormData();
  files?.forEach((ifile) => formData.append('file', ifile));
  formData.append('phone', phone);
  if (prescriptionId) formData.append('prescriptionId', prescriptionId);

  const toastId = toast.loading('Uploading...');
  try {
    await axios.post(`${END_POINT}/customer/public/Uploads/${customerId}`, formData, { headers: tenantHeaders() });
    toast.dismiss(toastId);
    toast.success('Files uploaded', { autoClose: 3000 });
    return true;
  } catch (error) {
    console.log('Check Error', error);
    toast.dismiss(toastId);
    toast.error(error?.response?.data?.error || 'Upload failed', { autoClose: 4000 });
    return false;
  }
};

const UploadPatientReports = () => {
  const { formId, patientId } = useParams();
  const [iphone, setiphone] = useState('');
  const [patientData, setPatientData] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const verifyCal = async () => {
    if (!iphone?.trim()) {
      toast.error('Please enter your phone number');
      return;
    }
    setIsVerifying(true);
    const iv = await verifyphone(iphone.trim(), patientId);
    setIsVerifying(false);
    const { data } = iv || {};
    if (!data) {
      toast.error('No patient found with this number');
    } else {
      setPatientData(data);
    }
  };

  const handleFileChange = (e) => {
    const picked = Array.from(e.target.files || []);
    setSelectedFiles((prev) => [...prev, ...picked]);
    // Reset so the same file can be picked again after removing it.
    e.target.value = '';
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prev) => prev.filter((file, i) => i !== index));
  };

  const handleUploadFiles = async () => {
    if (!selectedFiles.length) {
      toast.error('Please select at least one file');
      return;
    }
    setIsUploading(true);
    const ok = await UploadFiles(selectedFiles, patientData?._id, iphone.trim(), formId);
    setIsUploading(false);
    if (ok) setSelectedFiles([]);
  };

  return (
    <div className="h-fit min-h-[100vh] w-full bg-white p-4 md:p-10">
      <h1 className="text-3xl md:text-4xl my-5">Upload Reports</h1>
      <div>
        {patientData !== null ? (
          <div>
            <div className="w-full h-10 bg-gray-200 mb-3 flex items-center gap-5 px-4 md:px-10">
              <div className="text-black text-lg">{patientData?.firstName} {patientData?.surname}</div>
            </div>
            <div className="uploadSection flex flex-col">
              <div className="flex flex-col gap-2">
                <input id="file-input" type="file" onChange={handleFileChange} multiple={true} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 truncate" />
                <CameraCapture className="self-start" onCapture={(file) => setSelectedFiles((prev) => [...prev, file])} />
              </div>

              <div className="files-selected flex flex-col gap-2 mt-6 bg-slate-200 p-5 h-[50vh] overflow-y-auto">
                {selectedFiles.length === 0 && <div className="text-gray-500">No files selected (max 10 per upload)</div>}
                {selectedFiles?.map((f, index) => (
                  <div className="flex justify-between items-center py-2 px-4 border-b border-gray-200 bg-white rounded-lg" key={index}>
                    <div className="text-gray-700 text-lg truncate">{f?.name}</div>
                    <button onClick={() => handleRemoveFile(index)} className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded">
                      X
                    </button>
                  </div>
                ))}
              </div>
              <button onClick={handleUploadFiles} disabled={isUploading} className="mx-auto mt-4 bg-blue-500 text-xl hover:bg-blue-700 disabled:opacity-60 text-white font-bold py-3 px-6 rounded-lg">
                {isUploading ? 'Uploading...' : 'Submit'}
              </button>
            </div>
          </div>
        ) : (
          <div className="mx-auto bg-gray-100 shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col gap-3 p-3 max-w-[500px]">
            <label className="block text-gray-700 text-lg font-bold mb-2" htmlFor="report-number">
              Enter Registered Phone Number
            </label>
            <input onChange={(e) => setiphone(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && verifyCal()} value={iphone} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="report-number" type="tel" placeholder="Enter phone number" />
            <button onClick={verifyCal} disabled={isVerifying} className="bg-orange-500 hover:bg-orange-700 disabled:opacity-60 text-white font-bold py-2 px-4 rounded" type="submit">
              {isVerifying ? 'Verifying...' : 'Submit'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadPatientReports;
